import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CustomFiltersService {
  private flagSource = new BehaviorSubject('true');
  currentflag = this.flagSource.asObservable();
  constructor(private gtn: globals.GetTokenNow, private httpClient: HttpClient) {}
  schemaKeys(module) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = module;
    return this.httpClient.get(`${globals.domain}/team/schema-keys/`, updateQueries).pipe(map(res => res as any));
  }
  listMyFilters(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/team/custom-filters/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
  createFilter(body) {
    return this.httpClient.post(`${globals.domain}/team/custom-filters/create/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  viewFilter(filterId) {
    return this.httpClient.get(`${globals.domain}/team/custom-filters/${filterId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateFilter(body, filterId) {
    return this.httpClient
      .put(`${globals.domain}/team/custom-filters/${filterId}/update`, body, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  deleteFilter(filterId) {
    return this.httpClient
      .delete(`${globals.domain}/team/custom-filters/${filterId}/remove`, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  restoreFilter(filterId) {
    return this.httpClient
      .put(`${globals.domain}/team/custom-filters/${filterId}/restore`, {}, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  collapseMenu(flag) {
    this.flagSource.next(flag);
  }

}